import { useRef, useState } from 'react'
import { useAutoResize } from '@/hooks/use-auto-resize'

interface KeysStepProps {
  keys: string[]
  onBack: () => void
  onSave: (keys: string[]) => void
}

/**
 * Port of the step-999 detour in components/GiveawayNew.vue — the "paste your
 * keys here" textarea. Blank lines are dropped, which the original's
 * `split(/\n/)` kept as empty prizes.
 */
export function KeysStep({ keys, onBack, onSave }: KeysStepProps) {
  const [text, setText] = useState(keys.join('\n'))
  const textarea = useRef<HTMLTextAreaElement>(null)
  useAutoResize(textarea, text)

  const parsed = text
    .replace(/\r/g, '')
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)

  return (
    <div className="content-section">
      <textarea
        ref={textarea}
        className="with-margin small-margin description-field"
        placeholder="Type or paste your keys here"
        aria-label="Giveaway keys, one per line"
        value={text}
        onChange={(event) => setText(event.target.value)}
      />

      <div className="content-row upper">{parsed.length} Keys Added</div>

      <div className="footer">
        <div className="cta-row">
          <button type="button" className="cta" onClick={onBack}>
            Back
          </button>
          <button type="button" className="cta next" onClick={() => onSave(parsed)}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  )
}
